module.exports = __webpack_public_path__ + "img/35864-059.b86c7f18.jpg";